export default __webpack_public_path__ + "static/media/openSansRegular.d7d7b835.ttf";